import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context";
import CustomModal from "../../../src/components/modal";
import { UserOutlined } from "@ant-design/icons";

import { Avatar, Col, Row, Button, Divider } from "antd";
import styles from "./layout-header.module.css";
import { TContext, TUser } from "../../types/config";
import SendOTP from "../../pages/auth/reset-password";
import ProfileControlForm from "./profile-control";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignOut,
  faEnvelope,
  faPhone,
  faBuilding,
  faIdCard,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import AuthUtil from "../../utils/auth";
import Utils from "../../utils";

export default function SettingsForm() {
  const context: TContext = useContext(UserContext);
  const [userDetails, setUserDetails] = useState<TUser>(context?.user as TUser);

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  useEffect(() => {
    setUserDetails(context?.user as TUser);
  }, [context.user]);

  const handlePasswordClick = () => {
    setIsPasswordModalOpen(true); // Open Change Password modal
  };

  const handleModalCancel = () => {
    setIsPasswordModalOpen(false);
  };

  function signOut() {
    AuthUtil.logout();
    Utils.redirectUrl(`/login`);
  }

  const UserProfileContent: React.FC<{}> = () => (
    <div className={styles.profileCard}>
      <div className={styles.profileHeader}>
        <Avatar size={100} icon={<UserOutlined />} className={styles.avatar} />
        <div className={styles.profileInfo}>
          <h2 className={styles.userName}>
            {userDetails?.displayName || userDetails?.emailId}
          </h2>
          <p className={styles.userRole}>{userDetails?.roles?.[0]?.name}</p>
        </div>
      </div>
      <div className={styles.profileDetails}>
        <div className={styles.detailItem}>
          <FontAwesomeIcon icon={faEnvelope} className={styles.detailIcon} />
          <span>{userDetails?.emailId}</span>
        </div>
        <div className={styles.detailItem}>
          <FontAwesomeIcon icon={faPhone} className={styles.detailIcon} />
          <span>{userDetails?.mobileNo}</span>
        </div>
        <div className={styles.detailItem}>
          <FontAwesomeIcon icon={faBuilding} className={styles.detailIcon} />
          <span>{userDetails?.orgName}</span>
        </div>
        <div className={styles.detailItem}>
          <FontAwesomeIcon icon={faIdCard} className={styles.detailIcon} />
          <span>{userDetails?.roles?.[0]?.name}</span>
        </div>
        <div className={`${styles.detailItem}`}>
          <FontAwesomeIcon icon={faLock} className={styles.detailIcon} />
          <span
            className={`${styles.changePassword}`}
            onClick={handlePasswordClick}
          >
            Change Password
          </span>
        </div>
        <div className={styles.signOutButtonContainer}>
          <Button
            type="primary"
            danger
            size="large"
            className={styles.signOutButton}
            onClick={signOut}
            icon={<FontAwesomeIcon icon={faSignOut} />}
          >
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.settingsContainer}>
      <Row
        gutter={[16, 16]}
        style={{
          padding: "1rem",
        }}
      >
        {/* User Profile */}
        <Col xs={24} sm={24} md={10} lg={10} xl={10}>
          <UserProfileContent />
        </Col>

        {/*Profile Form */}
        <Col
          xs={24}
          sm={24}
          md={14}
          lg={14}
          xl={14}
          style={{
            marginTop: "3rem",

            overflowY: "auto",
          }}
        >
          <ProfileControlForm />
        </Col>
      </Row>

      <CustomModal
        title="Change Password"
        isOpen={isPasswordModalOpen}
        onOk={() => {}}
        onCancel={handleModalCancel}
        hideOkButton={true}
        hideCancelButton={true}
        okText=""
        cancelText=""
        // width="31%"
        style={{ maxWidth: "90%", minWidth: "300px" }}
      >
        <SendOTP handleModalCancel={handleModalCancel} />
      </CustomModal>
    </div>
  );
}
